import Vue from 'vue';
import Router from 'vue-router';
import Admin from './views/Admin.vue';
import Index from './views/Index.vue';
import Embed from './views/Embed.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/first-login',
      name: 'first-login',
      component: Admin,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: Admin,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
    },
    {
      path: '/admin/campaigns',
      name: 'campaigns-admin',
      component: Admin,
    },
    {
      path: '/admin/categories',
      name: 'categories-admin',
      component: Admin,
    },
    {
      path: '/admin/users',
      name: 'users-admin',
      component: Admin,
    },
    {
      path: '/admin/content',
      name: 'content-admin',
      component: Admin,
    },
    {
      path: '/admin/info',
      name: 'info-admin',
      component: Admin,
    },
    {
      path: '/embed',
      name: 'embed',
      component: Embed,
    },
    // This should be the last route to catch all unmatched routes
    {
      path: '*',
      name: 'not-found',
      component: Index,
    },
  ],
});
